import React, { useRef, useState } from 'react'
import { Drawer, Tag, Tooltip } from 'antd'
import { useDispatch } from 'react-redux'
import { DefaultTablePagination, displayDate, displayTime, longDisplayDate } from '../../components/_utils/appUtils'
import { TableComp } from 'sz-react-utils-lite'
import { ColumnWidth } from '../WebComponent/columnWidth'
import { getAllNewScheduleMeetingsFxn } from './actions'
import { LazyLoadImage } from 'react-lazy-load-image-component'

const ScheduleMeetingDrawer = (props) => {
  const { visible, onClose, agentId } = props
  const dispatch = useDispatch()
  const tableRef = useRef()
  const [countData, setCountData] = useState([])

  const apiRequest = async (params) => {
    return new Promise(async (resolve) => {
      params.agentId = agentId
      const { data, success, countData } = await dispatch(getAllNewScheduleMeetingsFxn(params))
      if (countData && countData.length > 0) {
        setCountData(countData)
      }
      resolve(data)
    })
  }

  const columns = [
    {
      title: '#',
      key: '_id',
      dataIndex: '_id',
      width: 50,
      render: function(text, record, index) {
        return index + 1
      }
    },
    {
      title: 'City/State/Country',
      key: 'agent',
      dataIndex: 'agent',
      width: 250,
      render: function(item) {
        if (!item) return '-'
        return (
          <ColumnWidth width={250}>
            <span>
              {item.companyName ? item.cityName : ''}
              / {item.companyName ? item.stateName : ''}
              / {item.companyName ? item.countryName : ''}
            </span>
          </ColumnWidth>
        )
      }
    },
    {
      title: 'Place',
      key: 'type',
      dataIndex: 'type',
      width: 100,
      render: function(item) {
        if (!item) return '-'
        return (
          <ColumnWidth width={250}>
            <span>
              {item}
            </span>
          </ColumnWidth>
        )
      }
    },
    {
      title: 'Date',
      key: 'fromTime',
      dataIndex: 'fromTime',
      width: 100,
      render: function(item) {
        if (!item) return '-'
        return (
          <ColumnWidth width={250}>
            <div className={'btn btn-default roundNew sm'}>
              <b>{displayDate(item)}</b>, {displayTime(item)}
            </div>
          </ColumnWidth>
        )
      }
    },
    {
      title: 'Minutes of meeting/Reason',
      key: 'notes',
      dataIndex: 'notes',
      width: 250,
      render: (item, record) => {
        let { workedToday, meetingDiscussion } = record
        return (
          <ColumnWidth width={250}>
             <span>
              {workedToday == 'Yes' ? meetingDiscussion : item}
            </span>
          </ColumnWidth>
        )
      }
    },
    {
      title: 'Photos',
      key: 'photos',
      dataIndex: 'photos',
      width: 250,
      render: function(photos) {
        if (!Array.isArray(photos) || photos.length === 0) return '-'
        return (
          <ColumnWidth width={250}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {photos.map((photo, index) => {
                return (
                  <Tooltip title={'Click to View'} key={index}>
                    <a key={index}
                       href={photo.url}
                       target='_blank'
                       rel='noopener noreferrer'>
                      <LazyLoadImage
                        src={photo.url}
                        alt={`Photo ${index + 1}`}
                        style={{ width: 'auto', height: 50, objectFit: 'cover', borderRadius: 4 }}
                      />
                    </a>
                  </Tooltip>
                )
              })}
            </div>
          </ColumnWidth>
        )
      }
    }
  ]

  return (
    <Drawer
      visible={visible}
      width={'75%'}
      placement='right'
      onClose={onClose}
      title='Schedule Meetings'>
      <div className='card'>
        <div className='card-header'>
          <div className='d-flex flex-wrap'>
            {Array.isArray(countData) &&
            countData.map((state) =>
              state && state.addedByUserId ? (
                <div key={state._id} className='btn btn-default roundNew2 sm' style={{ marginRight: 5 }}>
                            <span className='box-text'>
                              {state.user && state.user.name ? state.user.name : ''}
                            </span>
                  <div className='countCircle'>
                    {state.count ? state.count : ''}
                  </div>
                </div>
              ) : null
            )}
          </div>
        </div>
        {/* Optional: Card Header or Custom Container */}
        <div className='card-body table-responsive mt0'>

          <TableComp
            columns={columns}
            ref={tableRef}
            pagination={DefaultTablePagination({}, 10, [10, 20, 50, 100])}
            apiRequest={apiRequest}
            extraProps={{ scroll: { x: 1000 } }}
          />
        </div>
      </div>


    </Drawer>
  )
}

export default ScheduleMeetingDrawer
